import React from 'react';
import GameListWrapper from '../gameListWrapper';
import GameNotFound from '../gameNotFound';

export default function boostedOddsTemplate () {
    const {gameType, isAsian, regionId, competitionId, sportAlias, child, boostedOddsGameIds} = this.props;
    const { boostedOddsState } = this.state;
    if (boostedOddsState && Object.keys(boostedOddsState).length !== 0 || boostedOddsGameIds && Object.keys(boostedOddsGameIds).length !== 0) {
        return (
            <div className={`select-sport-contain-m ${gameType}`}>
                {
                    ((regionId || competitionId) && !child) ? <GameListWrapper gameType={gameType}
                        isAsian={isAsian}
                        sportAlias={sportAlias}
                        regionId={regionId}
                        boostedOddsGameIds={boostedOddsGameIds || boostedOddsState}
                        competitionId={competitionId} /> : child
                }
            </div>
        );
    } else {
        return <GameNotFound />;
    }
}